module.exports = __webpack_public_path__ + "img/procession.5e2f07b9.jpg";